import { artifactAtom } from "@/lib/store/artifact";
import { useAtomValue } from "jotai";

export const ArtifactPreview = () => {
  const { code: realCode, } = useAtomValue(artifactAtom);
  return <iframe className="size-full overflow-auto" srcDoc={realCode} />
}
